var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLaPublicidad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.667 25.667H42A2.333 2.333 0 0039.667 28v21A2.333 2.333 0 0042 51.333h11.667A2.333 2.333 0 0056 49V28a2.333 2.333 0 00-2.333-2.333zm0 21H42V30.333h11.667v16.334zm-7-42h-42A4.65 4.65 0 000 9.333v28A4.666 4.666 0 004.667 42H21v4.667h-4.667v4.666H35v-4.666h-4.667V42H35v-4.667H4.667v-28h42V21h4.666V9.333c0-2.59-2.1-4.666-4.666-4.666zM27.93 21l-2.263-7-2.264 7h-7.07l5.764 4.107-2.194 6.79 5.764-4.2 5.763 4.2-2.193-6.79L35 21h-7.07z",
    fill: "#54DCF2"
  })));
}
export default SvgIconLaPublicidad;